import { __decorate } from "tslib";
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
let LogoBand = class LogoBand extends LitElement {
    render() {
        return html `<div>
        <img src="assets/images/no_padding.png" alt="Franklin Templeton: Insieme verso il futuro" />
   </div>`;
    }
};
LogoBand.styles = [
    css `
    :host {
      width: 100%;
      display: block;
      background: var(--white);
    }

    div {
        background: var(--white);
        height: 5.25rem;
        margin: 0 5rem;
        display: flex;
        align-content: center;
        align-items: center;
    }

    img {
        width: 230px;
    }
  `
];
LogoBand = __decorate([
    customElement('logo-band')
], LogoBand);
export { LogoBand };
//# sourceMappingURL=logo-band.js.map